export var PUSH = 'ROUTER/PUSH';
export var REPLACE = 'ROUTER/REPLACE';
export var GO = 'ROUTER/GO';
export var GO_BACK = 'ROUTER/GO_BACK';
export var GO_FORWARD = 'ROUTER/GO_FORWARD';
export var LOCATION_CHANGE = 'ROUTER/LOCATION_CHANGE';